import { Periods } from 'constants/scheduling'

export const SUL_DEFAULT_FILTERS = {
  period: Periods.ALL_TIME,
  event_type_ids: []
}

const isNonDefaultFilter = (key, value) => JSON.stringify(value) !== JSON.stringify(SUL_DEFAULT_FILTERS[key])

export const getNonDefaultFilters = (params) => {
  const nonDefaultFilters = {}

  Object.keys(params).forEach((key) => {
    if (SUL_DEFAULT_FILTERS[key]) {
      if (isNonDefaultFilter(key, params[key])) {
        nonDefaultFilters[key] = params[key]
      }
    } else {
      nonDefaultFilters[key] = params[key]
    }
  })
  return nonDefaultFilters
}

const getNonDefaultFiltersForCount = (params) => {
  const nonDefaultFilters = {}

  Object.keys(SUL_DEFAULT_FILTERS).forEach((key) => {
    if (params?.[key] && isNonDefaultFilter(key, params[key])) {
      nonDefaultFilters[key] = params[key]
    }
  })
  return nonDefaultFilters
}

export const countNonDefaultFilters = ({ event_type_ids: eventTypeIds, ...params } = {}) => {
  const nonDefaultFilters = getNonDefaultFiltersForCount(params)
  let count = Object.keys(nonDefaultFilters).length

  if (eventTypeIds && isNonDefaultFilter('event_type_ids', eventTypeIds)) {
    count += eventTypeIds.length
  }

  return count
}
